// Hustota menu vyjádřená inline Tailwind třídami (CSS proměnné z prototypu `menu.css`
// `.phm-scope[data-density]` nahrazeny lookupem). Hodnoty 1:1 s prototypem.

import type { MenuDensity } from './menuTypes';

export interface DensityTokens {
  /** min-height řádku */
  readonly rowMinH: string;
  /** vertikální padding řádku */
  readonly rowPadY: string;
  /** font-size popisku */
  readonly text: string;
  /** velikost slotu vedoucí ikony v px (--phm-chip) */
  readonly leadSize: number;
  /** flex-basis sloupce (drill-down) */
  readonly colBasis: string;
  /** min-width sloupce */
  readonly colMinW: string;
}

export const MENU_DENSITY: Record<MenuDensity, DensityTokens> = {
  compact: {
    rowMinH: 'min-h-[25px]',
    rowPadY: 'py-phx-1_5',
    text: 'text-phx-sm',
    leadSize: 15,
    colBasis: 'basis-[232px]',
    colMinW: 'min-w-[232px]',
  },
  comfortable: {
    rowMinH: 'min-h-[29px]',
    rowPadY: 'py-phx-2_5',
    text: 'text-[12.5px]',
    leadSize: 16,
    colBasis: 'basis-[246px]',
    colMinW: 'min-w-[246px]',
  },
  cozy: {
    rowMinH: 'min-h-[34px]',
    rowPadY: 'py-phx-3_5',
    text: 'text-phx-md',
    leadSize: 17,
    colBasis: 'basis-[258px]',
    colMinW: 'min-w-[258px]',
  },
  ultra: {
    rowMinH: 'min-h-phx-control-sm',
    rowPadY: 'py-phx-1',
    text: 'text-[11.5px]',
    leadSize: 14,
    colBasis: 'basis-[220px]',
    colMinW: 'min-w-[220px]',
  },
};
